import { render, staticRenderFns } from "./TopHolder.vue?vue&type=template&id=5a76e9b6&scoped=true"
import script from "./TopHolder.vue?vue&type=script&lang=js"
export * from "./TopHolder.vue?vue&type=script&lang=js"
import style0 from "./TopHolder.vue?vue&type=style&index=0&id=5a76e9b6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a76e9b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JSH\\Desktop\\workspace\\yueqitong\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a76e9b6')) {
      api.createRecord('5a76e9b6', component.options)
    } else {
      api.reload('5a76e9b6', component.options)
    }
    module.hot.accept("./TopHolder.vue?vue&type=template&id=5a76e9b6&scoped=true", function () {
      api.rerender('5a76e9b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/public/components/TopHolder.vue"
export default component.exports